<template>
  <van-dropdown-menu direction="up" class="lang-menu">
    <van-dropdown-item v-model="value" :options="columns" @change="handleSetLanguage"/>
  </van-dropdown-menu>
</template>
<script>
import Cookies from "js-cookie";
import {getLanguage} from "@/lang";


export default {
  name: 'LangSelect',
  data() {
    return {
      value: Cookies.get('language') || getLanguage(),
      columns: [
        {
          text: '中文',
          value: 'zh'
        },
        {
          text: 'English',
          value: 'en'
        },
        {
          text: '日本語',
          value: 'ja'
        },
          {
          text: '한국어',
          value: 'ko'
        },
        {
          text: 'हिंदी',
          value: 'hi'
        },
          {
          text: 'Español',
          value: 'es'
        },
          {
            text: 'Portugal',
            value: 'pt'
        },
        {
          text: 'Français',
          value: 'fr'
        } ,
        {
          text: 'Deutsch',
          value: 'de'
        },
        {
          text: 'Pусский',
          value: 'py'
        },
        {
          text: 'Polski',
          value: 'pl'
        }
      ],
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
      getLanguage()
      location.reload()
    }
  }
}
</script>
<style scoped lang="scss">
.lang-menu{
  ::v-deep .van-dropdown-menu__bar{
    background: none;
    box-shadow:none;
  }
  ::v-deep .van-ellipsis{
    font-size: 16px;
  }
}
</style>